import useSWR from 'swr';

import type { TestRuleset } from '../useAbTesting/types';
import { useAbTesting } from '../useAbTesting/useAbTesting';

type UseAbTestResult = {
  ruleset: TestRuleset;
  isLoading: boolean;
  error: unknown;
};

/**
 * Enroll the user in an A/B test and return its ruleset, loading state, and error.
 *
 * Can be safely called from multiple sites without leading to enrollment race conditions.
 *
 * @param testId the name/id of the test
 */
export const useAbTest = (testId: string): UseAbTestResult => {
  const { getTestRuleset } = useAbTesting();

  const {
    data: ruleset,
    isLoading,
    error,
  } = useSWR(`abtest-${testId}`, () => getTestRuleset(testId));

  return { ruleset, isLoading, error };
};
